import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import { APP_ROUTE } from '../../../../constants';
import { BillingContainer } from '../../../../providers';

const STEPS_AMOUNT = new Array(5).fill('').map(Math.random);

const mapRouteToProgress = {
  [`/${APP_ROUTE.ONBOARDING}/${APP_ROUTE.WELCOME}`]: {
    text: 'Welcome',
    stepNumber: 1,
  },
  [`/${APP_ROUTE.ONBOARDING}/${APP_ROUTE.PROFILE}`]: {
    text: 'Personal profile',
    stepNumber: 2,
  },
  [`/${APP_ROUTE.ONBOARDING}/${APP_ROUTE.BUSINESS}`]: {
    text: 'Business type',
    stepNumber: 3,
  },
  [`/${APP_ROUTE.ONBOARDING}/${APP_ROUTE.BILLING}`]: {
    text: 'Select plan',
    stepNumber: 4,
  },
  [`/${APP_ROUTE.ONBOARDING}/${APP_ROUTE.BILLING}`]: {
    text: 'Add payment',
    stepNumber: 4,
  },
  [`/${APP_ROUTE.ONBOARDING}/${APP_ROUTE.CHECKOUT}`]: {
    text: 'Checkout',
    stepNumber: 4,
  },
  [`/${APP_ROUTE.ONBOARDING}/${APP_ROUTE.ADD_CLIENT}`]: {
    text: 'setup guide',
    stepNumber: 5,
  },
};
const OnboardingProgress = () => {
  const location = useLocation();
  const { text, stepNumber } = mapRouteToProgress[location.pathname] || {};
  const { state: billingState } = BillingContainer.useContainer();

  return (
    <div className="OnboardingModal__progress">
      {STEPS_AMOUNT.map((key, i) => {
        const isActive = i + 1 === stepNumber;
        const stepClasses = classnames('OnboardingModal__progress-step', {
          'OnboardingModal__progress-step--active': isActive,
        });
        if (stepNumber === 4) {
          return (
            <div key={key} className={stepClasses}>
              <div className="OnboardingModal__progress-text">
                {billingState.currentPage === 'Add Payment Method'
                  ? 'Add payment'
                  : 'Select plan'}
              </div>
            </div>
          );
        }
        return (
          <div key={key} className={stepClasses}>
            <div className="OnboardingModal__progress-text">{text}</div>
          </div>
        );
      })}
    </div>
  );
};

export default OnboardingProgress;
